import { useSystemEntityStore } from '#layers/runtime/public';
import { readLastWorkspace } from '#layers/workspace/utils/last-workspace';

/** Prefer the stored slug when the user still has access, else their first workspace. */
export function pickBackdropWorkspaceSlug(stored: string | null, memberSlugs: string[]): string | null {
	if (stored && memberSlugs.includes(stored)) return stored;
	return memberSlugs[0] ?? null;
}

export async function resolveBackdropWorkspaceSlug(userId: string | null | undefined): Promise<string | null> {
	if (!userId) return null;
	const user = await useSystemEntityStore().MonospaceUser.findFirst({
		filter: { id: userId },
		include: { workspaces: { include: { workspace: {} } } },
		fetchPolicy: 'fetch-only',
	});
	const slugs = (user?.workspaces ?? []).flatMap((m) => (m.workspace ? [m.workspace.apiName] : []));
	return pickBackdropWorkspaceSlug(readLastWorkspace(userId), slugs);
}
